import toast from "react-hot-toast";
import moment from "moment";

export function isPercentage(value) {
    // Regular expression to match a percentage value
    const percentageRegex = /^(\d+(\.\d+)?%$)|^100%$/;

    return percentageRegex.test(value);
}

export function toastSuccess(message) {
    toast.success(message);
}

export function toastError(error) {
    toast.error(error.response?.data?.message || error.response?.message || error.message);
}

/** Single toast for login failures (dedupes double submit; clearer timeout/network copy). */
export function toastLoginError(error) {
    let msg =
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.message ||
        "Something went wrong";
    if (error?.code === "ECONNABORTED" || error?.message?.includes?.("timeout")) {
        msg =
            "Login request timed out. Start the backend, set REACT_APP_API_BASE_URL to its URL (including port), and restart npm start.";
    } else if (error?.message === "Network Error" || error?.code === "ERR_NETWORK") {
        msg =
            "Cannot reach the API. Check that the backend is running and REACT_APP_API_BASE_URL matches its host and port.";
    }
    toast.error(msg, { id: "admin-login-error" });
}

/** Single toast for lead delete failures (dedupes rapid retries / double handlers). */
export function toastLeadDeleteError(error) {
    const msg =
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.message ||
        "Something went wrong";
    toast.error(msg, { id: "admin-lead-delete-error" });
}

/** Primary key from grid row (Sequelize uses `id`). */
export function getLeadRowId(row) {
    if (row == null) return undefined;
    return row.id ?? row._id;
}

export const formateDateString = (dateString, format = "ll") => {
    return moment(dateString).format(format);
}


export const formatCurrency = (input, currency = 'XOF') => {
    // Convert input to a number if it's a string
    const value = typeof input === 'string' ? parseFloat(input) : input;

    // Check if the input is a valid number
    if (isNaN(value)) {
        return '-';
    }

    const formattedCurrency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    }).format(value);

    return formattedCurrency;
}

export const formatPercentage = (input) => {
    // Convert input to a number if it's a string
    const value = typeof input === 'string' ? parseFloat(input) : input;

    // Check if the input is a valid number
    if (isNaN(value)) {
        return '-';
    }

    return `${value} %`;
}

// Convert digits in a chemical formula string to subscript digits for display
// Example: "NiCl2-6H2O" -> "NiCl₂-₆H₂O"
export const formatChemicalFormula = (input) => {
    if (input == null) return input;
    const sub = {
        '0': '₀', '1': '₁', '2': '₂', '3': '₃', '4': '₄',
        '5': '₅', '6': '₆', '7': '₇', '8': '₈', '9': '₉'
    };
    return String(input).replace(/[0-9]/g, (d) => sub[d] || d);
}